// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__V54Ib","file":"styles_file__3JOwq"};